import {
    getSelectedCover,
    getCustomerIdValue,
    getVehicleRecordIdValue,
    getInsuranceQuotationIdValue,
} from '../../../selectors/ugMotorInsurance/quote';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { COVER_PLANS } from '../../../actions/ugMotorInsurance/types';
import { getPersonalDetailsForm, getEmailIsValidated } from '../../../selectors/ugMotorInsurance/personalDetails';
import { setEmailIsValidated, triggerSendOtp } from '../../../actions/ugMotorInsurance/personalDetails';

export const submitPersonalDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {

            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const state = store.getState();

                const selectedCover = getSelectedCover(state);

                let resp;
                
                if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                    resp = await makeComprehensiveSubmission(state);

                    if (resp.data) {
                        store.dispatch(apiTransitionPayloadCollection.initial());
                    }
                }

                if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                    resp = await makeThirdPartySubmission(state);

                    if (resp.data) {
                        store.dispatch(apiTransitionPayloadCollection.initial());
                    }
                }
                

                // const emailIsValidated = getEmailIsValidated(state);

                // if (!emailIsValidated && selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                //     store.dispatch(triggerSendOtp());
                // }
            } catch (e) {
                console.error(e);

                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
};

const comprehensivePayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);
    const vehicleRecordId = getVehicleRecordIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    const personalDetails = getPersonalDetailsForm(state);

    const personalDetailsPayload = {
        insurance_id: customerId.value,
        quotation_id: insuranceQuotationId.value,
        vehicle_id: vehicleRecordId.value,
        firstName: personalDetails.firstName.value ? personalDetails.firstName.value : 'N/A',
        lastName: personalDetails.lastName.value ? personalDetails.lastName.value : 'N/A',
        fullName: `${personalDetails.firstName.value} ${personalDetails.lastName.value}`,
        dateOfBirth: personalDetails.dob.value ? personalDetails.dob.value : 'N/A',
        gender: personalDetails.gender.value ? personalDetails.gender.value : 'N/A',
        nationality: personalDetails.nationality.value ? personalDetails.nationality.value : 'N/A',
        occupation: personalDetails.occupation.value || 'N/A',
        idNumber: personalDetails.idNumber.value ? personalDetails.idNumber.value : 'N/A',
        tinNumber: personalDetails.tinNumber.value ? personalDetails.tinNumber.value : 'N/A',
        phoneNumber: personalDetails.phoneNumber.value ? personalDetails.phoneNumber.value : 'N/A',
        emailAddress: personalDetails.email.value ? personalDetails.email.value : 'N/A',
        postalAddress: personalDetails.postalAddress.value ? personalDetails.postalAddress.value : 'N/A',
        townOrCity: personalDetails.townOrCity?.value || 'N/A',
    };

    return {
        ...personalDetailsPayload,
    };
};

const makeComprehensiveSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/personal-details';

        return await axios.post(url, comprehensivePayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

const thirdPartyPayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);

    const personalDetails = getPersonalDetailsForm(state);

    const personalDetailsPayload = {
        id: customerId.value,
        firstName: personalDetails.firstName.value ? personalDetails.firstName.value : 'N/A',
        lastName: personalDetails.lastName.value ? personalDetails.lastName.value : 'N/A',
        dateOfBirth: personalDetails.dob.value ? personalDetails.dob.value : 'N/A',
        gender: personalDetails.gender.value ? personalDetails.gender.value : 'N/A',
        nationality: personalDetails.nationality.value ? personalDetails.nationality.value : 'N/A',
        occupation: personalDetails.occupation.value ? personalDetails.occupation.value : 'N/A',
        idNumber: personalDetails.idNumber.value ? personalDetails.idNumber.value : 'N/A',
        taxPinNumber: personalDetails.tinNumber.value ? personalDetails.tinNumber.value : 'N/A',
        phoneNumber: personalDetails.phoneNumber.value ? personalDetails.phoneNumber.value : 'N/A',
        emailAddress: personalDetails.email.value ? personalDetails.email.value : 'N/A',
        postalAddress: personalDetails.postalAddress.value ? personalDetails.postalAddress.value : 'N/A',
    };

    return {
        ...personalDetailsPayload,
    };
};

const makeThirdPartySubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/third-party/personal-details';

        return await axios.post(url, thirdPartyPayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
